import { render, staticRenderFns } from "./TheNewHeader.vue?vue&type=template&id=6e645216&scoped=true"
import script from "./TheNewHeader.js?vue&type=script&lang=js&external"
export * from "./TheNewHeader.js?vue&type=script&lang=js&external"
import style0 from "./TheNewHeader.scss?vue&type=style&index=0&id=6e645216&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e645216",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Logo/Logo.vue').default,TheGetTheAppButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheGetTheAppButton/TheGetTheAppButton.vue').default,AccountButtons: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/account/AccountButtons/AccountButtons.vue').default,BrandsList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/BrandsList/BrandsList.vue').default,TheBurgerButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheBurgerButton/TheBurgerButton.vue').default,TheMobileNavigation: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheMobileNavigation/TheMobileNavigation.vue').default,TheDesktopNavigation: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheDesktopNavigation/TheDesktopNavigation.vue').default})
